const reviews = [
  {
    name: "Rachel M.",
    location: "Midtown Anchorage, AK",
    rating: 5,
    text: "I needed a passport renewal fast for a work trip to Canada. Fast Passport Center had it back to me in 6 days. I was so relieved — the process was seamless and my agent kept me informed every single day.",
  },
  {
    name: "Cody T.",
    location: "Eagle River, AK",
    rating: 5,
    text: "Our family trip to Japan was two weeks away and my son's passport was expired. FPC had his new passport back to Eagle River in under a week. Incredible service — well worth every penny.",
  },
  {
    name: "Sarah K.",
    location: "South Anchorage, AK",
    rating: 5,
    text: "I made a paperwork error on my first attempt at the post office and it came back delayed. FPC reviewed everything, caught the issue, and resubmitted — passport arrived in 5 days. Never going the DIY route again.",
  },
];

export default function TestimonialsSection() {
  return (
    <section id="reviews" className="bg-white py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Reviews</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            What Anchorage Travelers Say
          </h2>
          <p className="text-gray-500 max-w-xl mx-auto text-base leading-relaxed">
            Real reviews from real Anchorage residents who used Fast Passport Center.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {reviews.map((r, i) => (
            <div key={i} className="bg-[#F7F8FA] border border-gray-200 rounded-lg p-6">
              <div className="flex items-center gap-1 mb-4">
                {[...Array(r.rating)].map((_, j) => (
                  <i key={j} className="ri-star-fill text-[#F6C344] text-sm"></i>
                ))}
              </div>
              <p className="text-gray-600 text-sm leading-relaxed mb-5 italic">&ldquo;{r.text}&rdquo;</p>
              <div>
                <p className="font-bold text-[#1A365D] text-sm">{r.name}</p>
                <p className="text-gray-400 text-xs">{r.location}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}